export default "__VITE_ASSET__C$D36KeH__"